import { render, staticRenderFns } from "./PartnersVue.vue?vue&type=template&id=108c6d3b&scoped=true"
import script from "./PartnersVue.vue?vue&type=script&lang=js"
export * from "./PartnersVue.vue?vue&type=script&lang=js"
import style0 from "./PartnersVue.vue?vue&type=style&index=0&id=108c6d3b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "108c6d3b",
  null
  
)

export default component.exports